import React, { useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'

import { BehaviorsLastUpdate, Container, Header, Title } from './styles'
import { Activities, BloodPressure, HeartRate, Sleep } from '../lastUpdate'
import { usePatient } from '~/context'
import { BehaviorTypes, IBehavior } from '~/interfaces'
import { fetchLastUpdateBehaviorsTracking, message } from '~/services'

export const BehaviorsTracking = (): JSX.Element => {
  const { patient } = usePatient()
  const { data: lastUpdateBehaviorsTracking } = useQuery(
    ['behaviours', patient.id],
    async () => await fetchLastUpdateBehaviorsTracking(patient.id),
    { enabled: !!patient }
  )

  const getBehavior = useCallback(
    (type: BehaviorTypes): IBehavior | undefined => lastUpdateBehaviorsTracking?.find(b => b.type === type),
    [lastUpdateBehaviorsTracking]
  )

  if (!lastUpdateBehaviorsTracking?.length) return <></>

  return (
    <Container>
      <Header>
        <Title>{message('behaviors.behavior')}</Title>
      </Header>
      <BehaviorsLastUpdate>
        <Sleep behavior={getBehavior('Sono')} />
        <HeartRate behavior={getBehavior('Avaliação Cardíaca')} />
        <BloodPressure behavior={getBehavior('Pressão Arterial')} />
        <Activities behavior={getBehavior('Exercício')} />
      </BehaviorsLastUpdate>
    </Container>
  )
}
